<template>
  <div class="sevenDay">
    <div class="one">
      <img v-lazy="require('../assets/day/index.png')" alt="">
      <div class="next" @click="scrollView('#two')"></div>
    </div>
    <div class="two" id="two">
      <img v-lazy="require(`../assets/day/${day}.png`)" alt="">
    </div>
    <div class="three">
      <img v-lazy="require('../assets/day/bottom.png')" alt="">
      <div class="video1" @click="playVideo('d15b750dc1aa50de6dee908818436257_d')"></div>
      <div class="video2" @click="playVideo('d15b750dc1d61b830680b01de4a79e75_d')"></div>
      <div class="video3" @click="playVideo('d15b750dc174cc3eba32d8c47e2e9ec9_d')"></div>
      <div class="video4" @click="playVideo('d15b750dc1b121c6cdd52eb22ee2df05_d')"></div>
      <div class="video5" @click="playVideo('d15b750dc172696c6c354ecaa0b2146d_d')"></div>
    </div>
    <div class="zhuce" @click="login()">注册并开通课程</div>
    <!-- 试听课程的视频进行弹框-->
    <div id="isShowMaskVideo" class="isShowMaskVideo" v-show="isShowMaskVideo">
      <!-- 关闭按钮的x号-->
      <span class="closeVideo" @click="destroy()">
        <img src="../assets/day/icon_fork.png" alt=""/>
      </span>
      <div id="player">
      </div>
    </div>
    <!-- 登录弹窗 -->
    <van-overlay :show="loginShow" @touchmove.prevent>
      <div class="wrapper" @click="loginShow = false">
        <div class="phoneArea" @click.stop>
          <div class="phoneBox"><span></span><div class="phone"><input v-model="phone" @input="phoneValidator" type="number" placeholder="请输入您的手机号"></div></div>
          <div class="validBox"><span></span><div class="valid"><input maxlength="4" v-model="validata" @input="tokenValidator" type="number" placeholder="请输入验证码"><span class="send" :class="is_send?'is_send':''" @click="send">{{item}}</span></div></div>
          <div class="btn" :class="active?'active':''" @click="join()">登录</div>
          <van-icon name="close" class="close" color="#fff" @click="loginShow = false"/>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
var player = null;
export default {
  data() {
    return {
      day: 7,// 套餐 7/15 天
      days: {
        3: '466',
        7: '462',
        15: '463'
      },
      userToken:null,// 用户token
      isShowMaskVideo: false,// 视频弹窗
      loginShow: false,// 登录注册弹窗
      active: false,// 是否允许登录
      is_send: false,// 是否允许发送验证码
      phone: '',// 手机号
      validata: '',// 验证码
      item: '发送验证码',// 密码右侧展示文字
      countdown: '',// 验证码倒计时
      forbid: false,// 是否允许发送验证码
    }
  },
  created() {
    this.day = Number(this.$route.query.day) || 7;
    this.id = this.days[this.day];
    this.userToken = this.$route.query.token;
    localStorage.setItem('CJKT_TOKEN', this.userToken);
    this.saler_id = this.$route.query.saler_id || '';
    this.agent_id = this.$route.query.agent_id || '';
  },
  methods: {
    // 操作电梯视图
    scrollView(id) {
      this.$el.querySelector(id).scrollIntoView({
        behavior: 'smooth', // 平滑过渡
        block: 'start' // 上边框与视窗顶部平齐--默认值
      });
    },
    //获取保利视频的相关信息
    async getPolyvInfo(pl_id){
      const res = await this.$get('mobile/video', { pl_id })
      if (res.code === 0) { return res.data }
      return false;
    },
    //点击课程试听进行视频播放
    async playVideo(pl_id) {
      const pl_obj = await this.getPolyvInfo(pl_id);
      this.isShowMaskVideo = true;
      // eslint-disable-next-line no-undef
      player = polyvPlayer({
        wrap: '#player',
        width:"100%",
        height: "100%",
        "vid": pl_obj.pl_id,
        playsafe: pl_obj.ployvToken,
        ts: pl_obj.ts,//保利的ts
        sign: pl_obj.sign,//保利的sign
        'forceH5': true,
        skinLocation:1,//默认是1
        // autoplay:true,
        screenshot:true,//开启视频截图
        // skinLocation:0
        preview: false, // 是否使用预览模式，到达预览时长后会停止播放
      });
    },
    // 关闭视频
    destroy() {
      this.isShowMaskVideo = false;
      player.destroy();
    },
    // 获取 csrf_token
    async getCsrf_token(){
      let url = "token/csrf"
      const {data: res} = await this.$get(url)
      return res.csrf_token;
    },
    // 手机号验证正确验证码可用
    phoneValidator() {
      if(/^1[0-9]{10}$/.test(this.phone)){
        this.is_send = true
      }else{
        this.is_send = false
        this.active = false
        return
      }
      if(/^1[0-9]{10}$/.test(this.phone) && this.validata.length == 4){
        this.active = true
      }else{
        this.active = false
      }
    },
    // 验证码验证正确登录可用
    tokenValidator() {
      if(this.validata.length>4){
        var arr = this.validata.split('')
        arr.pop()
        this.validata = arr.join('')
      }
      if(/^1[0-9]{10}$/.test(this.phone) && this.validata.length == 4){
        this.active = true
      }else{
        this.active = false
      }
    },
    // 发送验证码
    async send() {
      if(this.forbid){
        return
      }
      if(!this.is_send){
        this.$Toast.fail('请填写正确的手机号！')
        return
      }
      const csrf_token = await this.getCsrf_token()
      const res = await this.$post('verify/code',{phone:this.phone,csrf_token})
      if(res.code == 0){
        this.$Toast.success('发送成功！')
      }else{
        this.$Toast.fail('发送失败！')
      }
      this.countdown = 60
      this.setTime()
    },
    // 清空和设置倒计时
    setTime() {
      if (this.countdown == 0) {
        this.item="发送验证码";
        this.validata = ''
        this.forbid = false;
        return;
        } else {
          this.forbid = true;
          this.item="重新发送(" + this.countdown + ")";
          this.countdown--;
        }
      setTimeout(()=> {
        this.setTime()
      },1000)
    },
    login() {
      this.userToken ? this.subOrder() : this.loginShow = true
    },
    // 加入
    async join() {
      this.$Toast({
        duration: 0,
        type: 'loading',
        message: '登录中'
      })
      if(!this.is_send){
        this.$Toast('请填写正确手机号！')
        return
      }
      if(this.validata.length != 4){
        this.$Toast('请填写正确验证码！')
        return
      }
      const csrf_token = await this.getCsrf_token()
      const res = await this.$post('verify/sms',{phone:this.phone,code:this.validata,invite_code:this.invite_code,activity:'invite',csrf_token,saler_id: this.saler_id,agent_id: this.agent_id})
      if(res.code === 0){
        this.$Toast('登录成功！')
        localStorage.setItem('CJKT_TOKEN', res.data.token)
        this.loginShow = false;
        this.subOrder();
      }else{
        this.$Toast('验证码不正确或已过期')
      }
    },
    // 提交订单
    async subOrder() {
      if(!localStorage.getItem('CJKT_TOKEN')){
        return this.loginShow = true;
      }
      this.$Toast({duration: 0,type: 'loading',message: '加载中'})
      const csrf_token = await this.getCsrf_token()
      const res = await this.$post('buy/submit_order',{csrf_token, packages:this.id, token: localStorage.getItem('CJKT_TOKEN')})
      this.$Toast.clear()
      if(res.code == 40001) return this.$router.push({ path: 'daySuccess'})
      if(res.code == 40000 || res.code == 40003 || res.code == 40004 || res.code == 40005 || res.code == 40011) return this.loginShow = true
      this.$router.push({ path: 'pay', query: {id: this.id, saler_id: this.saler_id, agent_id: this.agent_id, order_id: res.data.id, phone: this.phone} })
    }
  },
}
</script>
<style lang="scss">
  .sevenDay{
    background: #535FC8;
    color: #333;
    padding-bottom: 2.8rem;
    img {
      width: 100%;
    }
    .one {
      position: relative;
      .next {
        position: absolute;
        bottom: 2rem;
        height: 4.2rem;
        width: 100%;
      }
    }
    .three {
      position: relative;
      >div {
        position: absolute;
        height: 5.7rem;
        width: 100%;
      }
      .video1 {
        top: 3.9rem;
      }
      .video2 {
        top: 13.25rem;
      }
      .video3 {
        top: 21.75rem;
      }
      .video4 {
        top: 30.55rem;
      }
      .video5 {
        top: 39.1rem;
      }
    }
    .zhuce {
      position: fixed;
      bottom: 0;
      width: 100%;
      height: 2.7rem;
      font-weight: 500;
      background: linear-gradient(90deg, #FF7936 0%, #FF4200 100%);
      line-height: 2.7rem;
      color: #fff;
      text-align: center;
      font-size: .9rem;
      letter-spacing: 0.1rem;
    }
    /*视频播放弹窗*/
    .isShowMaskVideo{
      position: fixed;
      top: 0px;
      left: 0px;
      width: 100%;
      bottom: 0px;
      background-color: rgba(0, 0, 0, .7);
      z-index: 10000;
      /*player用来放播放的视频的div*/
      #player{
        width: 100% !important;
        height: 12rem !important;
        position: fixed;
        top: 50%;
        transform: translatey(-50%);
      }
      .closeVideo{
        color: #ffffff;
        float: right;
        margin-top: .5rem;
        margin-right: .5rem;
        width: .8rem;
        height: .8rem;
        img{
          width: .8rem;
          height: .8rem;
        }
      }
    }
    /*登录弹窗*/
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .phoneArea {
        width: 13.8rem;
        height: 10rem;
        background: #FFFFFF;
        border-radius: .75rem;
        position: relative;
        padding: 1.25rem;
        box-sizing: border-box;
        h5{
          color: #333;
          font-size: .9rem;
          font-weight: 500;
          text-align: center;
          margin-top: .3rem;
        }
        .close{
          width: 1.35rem;
          height: 1.35rem;
          position: absolute;
          bottom: -3rem;
          left: calc(50% - .675rem);
        }
        .phoneBox >span{
          background: url(../assets/day/icon_phone@2x.png) no-repeat;
          background-size: .85rem .85rem;
        }
        .validBox >span{
          background: url(../assets/day/icon_code@2x.png) no-repeat;
          background-size: .85rem .85rem;
        }
        >div{
          margin-top: 1.2rem;
          font-size: .65rem;
          display: flex;
          align-items: center;
          >span{
            width: .85rem;
            height: .85rem;
            flex-shrink: 0;
          }
        }
        input{
          box-sizing: border-box;
          -webkit-appearance:none;
          -moz-appearance: none;
          height: 1.3rem;
          outline:0;
          text-indent: .5rem;
          width: 100%;
          border: none;
        }
        .phone, .valid{
          width: 11rem;
          margin-left: .5rem;
          border-bottom:1px solid #aaa;
          display: flex;
          align-items: center;
          flex: 1;
        }
        .valid .send{
          flex-shrink: 0;
          color: #999;
          padding-left: .4rem;
        }
        .valid .send.is_send{
          color: #FA2B28;
        }
        .btn{
          margin: 1rem auto 0;
          width: 10rem;
          height: 1.9rem;
          background: #FF293E;
          border-radius: .95rem;
          opacity: 0.39;
          text-align: center;
          font-size: .95rem;
          color: #fff;
          justify-content: center;
          &.active{
            opacity: 1;
          }
        }
      }
    }
  }
</style>
